import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/LegoView.vue'),
    },
    {
      path: '/lego',
      name: 'lego',
      component: () => import('../views/LegoView.vue'),
    },
    {
      path: '/parts',
      name: 'parts',
      component: () => import('../views/LegoPartsView.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
    },
  ],
})

export default router
